import type { Props as TippyProps } from 'tippy.js'

export const defaultProps: Partial<TippyProps> = {
  allowHTML: true,
  interactive: true,
  theme: 'light',
  appendTo: () => document.body,
}
